import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5628%3A780
 *
 * @param {SvgIconProps} props - svg props
 */
export const VolumeMuteIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M7.5 9C7.22386 9 7 9.22386 7 9.5V14.5C7 14.7761 7.22386 15 7.5 15H10.1716C10.702 15 11.2107 15.2107 11.5858 15.5858L15.1464 19.1464C15.4614 19.4614 16 19.2383 16 18.7929V5.20711C16 4.76165 15.4614 4.53857 15.1464 4.85355L11.5858 8.41421C11.2107 8.78929 10.702 9 10.1716 9H7.5Z' fill={color}/>
        </SvgIcon>
    )
}

export default VolumeMuteIcon
